import { render, staticRenderFns } from "./CardSections.vue?vue&type=template&id=24c5bbbf&scoped=true"
import script from "./CardSections.vue?vue&type=script&lang=js"
export * from "./CardSections.vue?vue&type=script&lang=js"
import style0 from "./CardSections.vue?vue&type=style&index=0&id=24c5bbbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c5bbbf",
  null
  
)

export default component.exports